import { Box, Container, Stack, Typography } from '@mui/material';

const steps = [
  {
    number: '01',
    title: 'Create Your Account',
    description: 'Sign up in under 2 minutes. No credit card required. Enter your company details and admin information.',
    color: '#3d7aff',
  },
  {
    number: '02',
    title: 'Import Your Team',
    description: 'Bulk upload employees via CSV or invite them individually via email. Set up departments and role templates.',
    color: '#c9b107',
  },
  {
    number: '03',
    title: 'Go Live',
    description: 'Start managing onboarding, training, compliance, and industrial relations from day one. We handle the paperwork.',
    color: '#22c55e',
  },
];

export function HowItWorksSection() {
  return (
    <Box sx={{ py: 14 }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', mb: 10 }}>
          <Typography sx={{ color: '#6b7a99', fontSize: 14, fontWeight: 500, letterSpacing: '0.08em', textTransform: 'uppercase', mb: 2 }}>
            Simple Setup
          </Typography>
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: 32, md: 48 },
              fontWeight: 700,
              letterSpacing: '-0.02em',
              color: '#f0f0f5',
            }}
          >
            Get Started in 3 Steps
          </Typography>
        </Box>

        <Stack spacing={0}>
          {steps.map((step, i) => (
            <Box key={step.number}>
              <Stack
                direction={{ xs: 'column', md: 'row' }}
                spacing={4}
                alignItems={{ md: 'center' }}
                sx={{
                  py: 4,
                  borderBottom: i < steps.length - 1 ? '1px solid rgba(255,255,255,0.06)' : 'none',
                }}
              >
                <Box
                  sx={{
                    width: 72,
                    height: 72,
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: `2px solid ${step.color}40`,
                    backgroundColor: `${step.color}10`,
                    flexShrink: 0,
                  }}
                >
                  <Typography sx={{ fontSize: 24, fontWeight: 800, color: step.color }}>
                    {step.number}
                  </Typography>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="h5" sx={{ fontWeight: 600, color: '#f0f0f5', mb: 1 }}>
                    {step.title}
                  </Typography>
                  <Typography sx={{ color: '#a0a5b5', lineHeight: 1.6, maxWidth: 500 }}>
                    {step.description}
                  </Typography>
                </Box>
              </Stack>
            </Box>
          ))}
        </Stack>
      </Container>
    </Box>
  );
}
